<div class="park-row">
    <!-- Park Hours -->
    <finder-section
        id="{{location.urlFriendlyId}}-park-hours"
        [labels]="{ sectionTitle: labels.hours }"
        [locationTitle]="location.title"
        [disableDeepLink]="true"
        [expanded]="true">
        <div class="row">
            <div class="day" *ngFor="let date of dateRange?.dates; let dateIndex = index">
                <div class="permanent-schedule hours" *ngIf="permanentSchedule">
                    <strong class="type">{{permanentSchedule.type}}</strong>
                    <span class="time">{{permanentSchedule.time}}</span>
                </div>
                <ng-container *ngIf="location.schedules.length; else emptyParkHours">
                    <div class="hours" *ngFor="let group of location.schedules">
                        <ng-container *ngTemplateOutlet="link; context: {$implicit: group}"> </ng-container>
                        <ng-container *ngTemplateOutlet="group?.schedules[date] ? scheduleTime : emptySchedule;
                                context: {$implicit: group, date, formattedDate: dateRange.formattedDates[dateIndex]?.fullDate}">
                        </ng-container>
                    </div>
                </ng-container>
                <ng-template #emptyParkHours>
                    <div class="hours">
                        <ng-container *ngTemplateOutlet="emptySchedule;
                            context:{formattedDate: dateRange.formattedDates[dateIndex]?.fullDate}">
                        </ng-container>
                    </div>
                </ng-template>
            </div>
        </div>
    </finder-section>
    <!-- Events -->
    <ng-container *ngFor="let section of sections">
        <finder-section
            [id]="section.id"
            [labels]="section.labels"
            [locationTitle]="location.title"
            [disableDeepLink]="true"
            [expanded]="false">
            <div class="events">
                <ng-container *ngIf="section?.data.length; else emptyRow">
                    <div class="event" *ngFor="let event of section.data; let first = first">
                        <div class="hours" *ngFor="let date of dateRange?.dates; let dateIndex = index">
                            <ng-container  *ngTemplateOutlet="permanentActivity; context: {section: section, first: first}"></ng-container>
                            <ng-container
                                *ngTemplateOutlet="link; context: {$implicit: event}">
                            </ng-container>
                            <ng-container
                                *ngTemplateOutlet="event?.schedules[date] ? scheduleTime : emptySchedule;
                                    context: {$implicit: event, date, formattedDate: dateRange.formattedDates[dateIndex]?.fullDate}">
                            </ng-container>
                        </div>
                    </div>
                </ng-container>
                <ng-template #emptyRow>
                    <div class="event">
                        <div class="hours" *ngFor="let date of dateRange?.dates; let dateIndex = index">
                            <ng-container *ngTemplateOutlet="emptySchedule; context:{formattedDate: dateRange.formattedDates[dateIndex]?.fullDate}"></ng-container>
                        </div>
                    </div>
                </ng-template>
            </div>
        </finder-section>
    </ng-container>
    <!-- Blockouts -->
    <finder-section *ngIf="blockouts?.data.length"
        [id]="blockouts.id"
        [labels]="blockouts.labels"
        [disableDeepLink]="true"
        [expanded]="false">
        <div class="row">
            <div class="day" *ngFor="let date of dateRange?.dates; let dateIndex = index">
                <ng-container *ngFor="let blockout of blockouts.data">
                    <span *ngIf="blockout.date | inArray: date" class="blockout">
                        {{blockout.name}}
                    </span>
                </ng-container>
            </div>
        </div>
    </finder-section>

    <!-- See What's closed for Refurbishtment -->
    <div class="closed-facilities" *ngIf="location.closedFacilities">
        <finder-anchor [href]="closedForRefurbishmentLink">
            {{location.closedForRefurbishmentLink?.text}}
        </finder-anchor>
    </div>
</div>

<!-- Renders Schedule -->
<ng-template #scheduleTime let-entity let-date="date" let-formattedDate="formattedDate">
    <ng-container *ngFor="let schedule of entity.schedules[date]">
        <span class="visually-hidden"> {{schedule.time}}, {{formattedDate}}</span>
        <span class="schedules" aria-hidden="true">{{schedule.time}}</span>
    </ng-container>
</ng-template>

<!-- Renders Empty Schedule -->
<ng-template #emptySchedule let-entity let-formattedDate="formattedDate">
    <!-- Screen reader copy changes depending of it is for a park hour or an event -->
    <span class="visually-hidden">
        {{!entity?.group && labels.emptyHours?.availability ?
            labels.emptyHours?.availability :
            labels.emptyHours?.operating}}: {{formattedDate}}
    </span>
    <span class="name empty-schedule" aria-hidden="true">-</span>
</ng-template>

<!-- Renders the entity (Location/Event) title as Finder Link or Plain Text -->
<ng-template #link let-entity let-date="date">
    <finder-anchor *ngIf="entity.href && showLinks; else noLink"
        ariaLabel="{{entity.name}} - {{location.title}}"
        [href]="entity.href">
        {{entity.name}}
    </finder-anchor>
    <ng-template #noLink>
        <span class="name" *ngIf="entity.name">{{entity.name}}</span>
    </ng-template>
</ng-template>

<!-- Renders Permanent Activity -->
<ng-template #permanentActivity let-section="section" let-first="first">
    <ng-container *ngIf="section?.permanentActivity && first">
        <div class="permanent-activity" *ngFor="let activity of section.permanentActivity">
            <finder-anchor
                class="name"
                *ngIf="activity.href; else noAnchor"
                [href]="activity.href"
                [linkId]="activity.linkId"
            >
                <strong>
                    {{activity.name}}
                </strong>
            </finder-anchor>
            <ng-template #noAnchor>
                <strong class="name">{{activity.name}}</strong>
                <span>{{activity.schedules}}</span>
            </ng-template>
        </div>
    </ng-container>
</ng-template>
